import {} from '../../../../../types/systemEvent'
import {
	CLINICAL_METABOLIC_STAT_ACTION_TYPES,
	ClinicalMetabolicStatAction,
	ClinicalMetabolicStatState,
} from '../../../../../types/clinical'

const initialState: ClinicalMetabolicStatState = {
	bgEvents: [],
	bpEvents: [],
	weightEvents: [],
	pedometerEvents: [],
}

export default (
	state = initialState,
	action: ClinicalMetabolicStatAction
): ClinicalMetabolicStatState => {
	switch (action.type) {
		case CLINICAL_METABOLIC_STAT_ACTION_TYPES.GET_BG_EVENTS: {
			return {
				...state,
				bgEvents: action.payload,
			}
		}
		case CLINICAL_METABOLIC_STAT_ACTION_TYPES.GET_BP_EVENTS: {
			return {
				...state,
				bpEvents: action.payload,
			}
		}
		case CLINICAL_METABOLIC_STAT_ACTION_TYPES.GET_WEIGHT_EVENTS: {
			return {
				...state,
				weightEvents: action.payload,
			}
		}
		case CLINICAL_METABOLIC_STAT_ACTION_TYPES.GET_PEDOMETER_EVENTS: {
			return {
				...state,
				pedometerEvents: action.payload,
			}
		}
		default: {
			return state
		}
	}
}
